export const USER_ROLES = {
  REGULAR_USER: 'REGULAR_USER',
  INTERNAL_USER: 'INTERNAL_USER',
  SALES_OPERATIONS_USER: 'SALES_OPERATIONS_USER',
  REWRITE_USER: 'REWRITE_USER',
};
